<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'lefticonrighttext',
})
</script>
<template>
    <div v-if="data" >
      <contenttitle :data="data" ></contenttitle>
      <a-row :gutter="[30,30]">
        <a-col :sm="{span:24}" :md="{span:10}">
          <a-image class="box-shadow" :src="addip(data.pic)" :alt="data.name"  />
        </a-col>
        <a-col :sm="{span:24}" :md="{span:14}">
          <div class="content-box " v-for="(item,i) in data.child" :key="i">
                <h4> <SendOutlined class="margin-right text-primary"/> {{ item.name }}</h4>
                <h5 v-if="item.sub">{{ item.sub }}</h5>
                <div class="padding-tb" v-if="item.contents" v-html="item.contents"></div>
            </div>
        </a-col>
      </a-row>
    </div>
</template>
<script setup lang="ts" name="lefticonrighttext">
import {defineComponent,defineProps } from 'vue'
import {addip,getCol} from '@/utils/util'
import { ArrowRightOutlined,SendOutlined } from '@ant-design/icons-vue';
defineProps({
  data:Object
})
</script>
